import React, { useState, useMemo } from "react";
import "../Home/theme.css"; // Import the CSS file
import toneblueg from "../../Assesst/laminance blue tone glossy.png";
import toneblue from "../../Assesst/laminance blue tone matte.png";
import CelestialBlue from "../../Assesst/laminance Celestial Blueglossy.png";
import CelestialBlueg from "../../Assesst/laminance Celestial Blue matee.png";
import pabblegrayg from "../../Assesst/Laminance Pabble grayG.png"
import pabblegray from "../../Assesst/Laminance Pabble grayM.png"
import Warmgrayg from "../../Assesst/Laminance Warm grayG .png"
import Warmgray from "../../Assesst/Laminance Warm grayM.png"
import Mossgrayg from "../../Assesst/Laminance Moss gray G.png"
import Mossgray from "../../Assesst/Laminance Moss gray M.png"
import Palegrayg from "../../Assesst/Laminance palegrayg.png"
import Palegray from "../../Assesst/Laminance palegraym.png"
import folkestonefrayg  from "../../Assesst/folkestonefrayg.png"
import folkestonefray from "../../Assesst/folkestonefraym.png"
import Platinum from "../../Assesst/Platinumgmm.png"
import Platinumg from "../../Assesst/Platinumgg.png"
import smokeg from "../../Assesst/smokeg.png"
import smoke from "../../Assesst/smoke.png"
import silvergrayg from "../../Assesst/silvergrayg.png"
import silvergray from "../../Assesst/silvergray.png"
import Ceramicg from "../../Assesst/Ceramicg.png"
import Ceramic from "../../Assesst/Ceramic.png"
import Champagneg from "../../Assesst/Champagneg.png"
import Champagne from "../../Assesst/Champagne.png"
import MysoreIvoryg from "../../Assesst/MysoreIvoryg.png"
import MysoreIvory from "../../Assesst/MysoreIvory.png"
import InteriorWhiteg from "../../Assesst/InteriorWhiteg.png"
import InteriorWhite from "../../Assesst/InteriorWhite.png"
import SnowWhiteg from "../../Assesst/SnowWhiteg.png"
import SnowWhite from "../../Assesst/SnowWhite.png"
import RoyalWhiteg from "../../Assesst/RoyalWhiteg.png"
import RoyalWhite from "../../Assesst/RoyalWhite.png"
import CandyWhiteg from "../../Assesst/CandyWhiteg.png"
import CandyWhite from "../../Assesst/CandyWhite.png"
import WhiteLilyg from "../../Assesst/WhiteLilyg.png"
import WhiteLily from "../../Assesst/WhiteLily.png"
import RoyalGreyg from "../../Assesst/RoyalGrey.png"
import RoyalGrey from "../../Assesst/RoyalGreym.png"
import AshGreyg from "../../Assesst/AshGreyg.png"
import AshGrey from "../../Assesst/AshGrey.png"
import GreyStoneg from "../../Assesst/GreyStoneg.png"
import GreyStone from "../../Assesst/GreyStone.png"
import PumicGreyg from "../../Assesst/PumicGreyg.png"
import PumicGrey from "../../Assesst/matem.png"
import DoveGreyg from "../../Assesst/DoveGreyg.png"
import DoveGrey from "../../Assesst/DoveGrey.png"
import GothicGreyg from "../../Assesst/GothicGreyg.png"
import GothicGrey from "../../Assesst/GothicGrey.png"
import MistyGreyg from "../../Assesst/MistyGreyg.png"
import MistyGrey from "../../Assesst/MistyGrey.png"
import AutumnLeafg from "../../Assesst/AutumnLeafg.png"
import AutumnLeaf from "../../Assesst/AutumnLeaf.png"
import CobbleStoneg from "../../Assesst/CobbleStoneg.png"
import CobbleStone from "../../Assesst/CobbleStone.png"
import Slateg from "../../Assesst/Slateg.png"
import Slate from "../../Assesst/Slate.png"
import PearlBlackg from "../../Assesst/PearlBlackg.png"
import PearlBlack from "../../Assesst/PearlBlack.png"
import Blackg from "../../Assesst/Blackg.png"
import Black from "../../Assesst/Black.png"
import Almondg from "../../Assesst/Almondg.png"
import Almond from "../../Assesst/Almond.png"
import Corng from "../../Assesst/Corng.png"
import Corn from "../../Assesst/Corn.png"
import Magnoliag from "../../Assesst/Magnolia.png"
import Magnolia from "../../Assesst/Magnoliag.png"
import BritishBuffg from "../../Assesst/BritishBuffg.png"
import BritishBuff from "../../Assesst/BritishBuff.png"
import LightBeigeg from "../../Assesst/LightBeigeg.png"
import LightBeige from "../../Assesst/LightBeige.png"
import Peanutg from "../../Assesst/Peanutg.png"
import Peanut from "../../Assesst/Peanut.png"
import Barleyg from "../../Assesst/Barleyg.png"
import Barley from "../../Assesst/Barley.png"
import Oysterg from "../../Assesst/Oysterg.png"
import Oyster from "../../Assesst/Oyster.png"
import IrishCreamg from "../../Assesst/IrishCreamg.png"
import IrishCream from "../../Assesst/IrishCream.png"
import Beigeg from "../../Assesst/Beigeg.png"
import Beige from "../../Assesst/Beige.png"
import Sandalg from "../../Assesst/Sandalg.png"
import Sandal from "../../Assesst/Sandal.png"
import Khakig from "../../Assesst/Khakig.png"
import Khaki from "../../Assesst/Khaki.png"
import Cappucciong from "../../Assesst/Cappucciong.png"
import Cappuccion from "../../Assesst/Cappuccion.png" 
import Tang from "../../Assesst/Tang.png"
import Tan from "../../Assesst/Tan.png" 
import Larkg from "../../Assesst/Larkg.png"
import Lark from "../../Assesst/Lark.png" 
import Browng from "../../Assesst/Browng.png"
import Brown from "../../Assesst/Brown.png" 
import Mochag from "../../Assesst/Mochag.png"
import Mocha from "../../Assesst/Mocha.png" 
import Chocolateg from "../../Assesst/Chocolateg.png"
import Chocolate from "../../Assesst/Chocolate.png" 

const OrnaMatte = "/assets/Images/Ornamatte-brochure-3[1]_1.jpg";
const OrnaMatte2 = "/assets/Images/Ornamatte-brochure-3[1]_2.jpg";
const OrnaMatte3 = "/assets/Images/Ornamatte-brochure-3[1]_3.jpg";
const OrnaMatte4 = "/assets/Images/Ornamatte-brochure-3[1]_4.jpg";


const products = [
  
 

  // Shaker - Matte Products (M)
  { id: 5, name: "21369 Pebble Grey", category: "Shaker", subcategory: "Matte", img: pabblegray },
  { id: 7, name: "21029 Warm Grey", category: "Shaker", subcategory: "Matte", img: Warmgray },
  { id: 9, name: "21109 Moss Grey", category: "Shaker", subcategory: "Matte", img: Mossgray },
  { id: 11, name: "22169 Pale Grey", category: "Shaker", subcategory: "Matte", img: Palegray },
  { id: 13, name: "21019 Folkstone Grey", category: "Shaker", subcategory: "Matte", img: folkestonefray },
  { id: 15, name: "21059 Platinum", category: "Shaker", subcategory: "Matte", img: Platinum },
  { id: 17, name: "21071 Smoke", category: "Shaker", subcategory: "Matte", img: smoke },
  { id: 19, name: "21069 Silver Grey", category: "Shaker", subcategory: "Matte", img: silvergray },
  { id: 21, name: "21161 Ceramic", category: "Shaker", subcategory: "Matte", img: Ceramic },
  { id: 23, name: "21187 Champagne", category: "Shaker", subcategory: "Matte", img: Champagne },
  { id: 25, name: "24087 Mysore Ivory", category: "Shaker", subcategory: "Matte", img: MysoreIvory },
  { id: 27, name: "21341 Interior White", category: "Shaker", subcategory: "Matte", img: InteriorWhite },
  { id: 29, name: "21141 Snow White", category: "Shaker", subcategory: "Matte", img: SnowWhite },
  { id: 31, name: "21581 Royal White", category: "Shaker", subcategory: "Matte", img: RoyalWhite },
  { id: 33, name: "21941 Candy White", category: "Shaker", subcategory: "Matte", img: CandyWhite },
  { id: 35, name: "21081 White Lily", category: "Shaker", subcategory: "Matte", img: WhiteLily },
  { id: 37, name: "21099 Royal Grey", category: "Shaker", subcategory: "Matte", img: RoyalGrey },
  { id: 39, name: "21089 Ash Grey", category: "Shaker", subcategory: "Matte", img: AshGrey },
  { id: 41, name: "21009 Grey Stone", category: "Shaker", subcategory: "Matte", img: GreyStone },
  { id: 43, name: "21321 Pumic Grey", category: "Shaker", subcategory: "Matte", img: PumicGrey },
  { id: 45, name: "22079 Dove Grey", category: "Shaker", subcategory: "Matte", img: DoveGrey },
  { id: 47, name: "22059 Gothic Grey", category: "Shaker", subcategory: "Matte", img: GothicGrey },
  { id: 49, name: "21039 Misty Grey", category: "Shaker", subcategory: "Matte", img: MistyGrey },
  { id: 51, name: "22119 Autumn Leaf", category: "Shaker", subcategory: "Matte", img: AutumnLeaf },
  { id: 53, name: "22129 Cobble Stone", category: "Shaker", subcategory: "Matte", img: CobbleStone },
  { id: 55, name: "22099 Slate", category: "Shaker", subcategory: "Matte", img: Slate },
  { id: 57, name: "22109 Pearl Black", category: "Shaker", subcategory: "Matte", img: PearlBlack },
  { id: 59, name: "21066 Black", category: "Shaker", subcategory: "Matte", img: Black },
  { id: 61, name: "21087 Almond", category: "Shaker", subcategory: "Matte", img: Almond },
  { id: 63, name: "21387 Corn", category: "Shaker", subcategory: "Matte", img: Corn },
  { id: 65, name: "21017 Magnolia", category: "Shaker", subcategory: "Matte", img: Magnolia },
  { id: 67, name: "22107 British Buff", category: "Shaker", subcategory: "Matte", img: BritishBuff },
  { id: 69, name: "21054 Light Beige", category: "Shaker", subcategory: "Matte", img: LightBeige },
  { id: 71, name: "21061 Peanut", category: "Shaker", subcategory: "Matte", img: Peanut },
  { id: 73, name: "21051 Barley", category: "Shaker", subcategory: "Matte", img: Barley },
  { id: 75, name: "21007 Oyster", category: "Shaker", subcategory: "Matte", img: Oyster },
  { id: 77, name: "21027 Irish Cream", category: "Shaker", subcategory: "Matte", img: IrishCream },
  { id: 79, name: "21037 Beige", category: "Shaker", subcategory: "Matte", img: Beige },
  { id: 81, name: "21077 Sandal", category: "Shaker", subcategory: "Matte", img: Sandal },
  { id: 83, name: "21097 Khaki", category: "Shaker", subcategory: "Matte", img: Khaki },
  { id: 85, name: "22137 Cappuccion", category: "Shaker", subcategory: "Matte", img: Cappuccion },
  { id: 87, name: "21127 Tan", category: "Shaker", subcategory: "Matte", img: Tan },
  { id: 89, name: "22197 Lark", category: "Shaker", subcategory: "Matte", img: Lark },
  { id: 91, name: "22127 Brown", category: "Shaker", subcategory: "Matte", img: Brown },
  { id: 93, name: "21038 Mocha", category: "Shaker", subcategory: "Matte", img: Mocha },
  { id: 95, name: "21028 Chocolate", category: "Shaker", subcategory: "Matte", img: Chocolate },

  // Shaker - Gloss Products (G)
  { id: 6, name: "21369 Pebble Grey", category: "Shaker", subcategory: "Gloss", img: pabblegrayg },
  { id: 8, name: "21029 Warm Grey", category: "Shaker", subcategory: "Gloss", img: Warmgrayg },
  { id: 10, name: "21109 Moss Grey", category: "Shaker", subcategory: "Gloss", img: Mossgrayg },
  { id: 12, name: "22169 Pale Grey", category: "Shaker", subcategory: "Gloss", img: Palegrayg },
  { id: 14, name: "21019 Folkstone Grey", category: "Shaker", subcategory: "Gloss", img: folkestonefrayg },
  { id: 16, name: "21059 Platinum", category: "Shaker", subcategory: "Gloss", img: Platinumg },
  { id: 18, name: "21071 Smoke", category: "Shaker", subcategory: "Gloss", img: smokeg },
  { id: 20, name: "21069 Silver Grey", category: "Shaker", subcategory: "Gloss", img: silvergrayg },
  { id: 22, name: "21161 Ceramic", category: "Shaker", subcategory: "Gloss", img: Ceramicg },
  { id: 24, name: "21187 Champagne", category: "Shaker", subcategory: "Gloss", img: Champagneg },
  { id: 26, name: "24087 Mysore Ivory", category: "Shaker", subcategory: "Gloss", img: MysoreIvoryg },
  { id: 28, name: "21341 Interior White", category: "Shaker", subcategory: "Gloss", img: InteriorWhiteg },
  { id: 30, name: "21141 Snow White", category: "Shaker", subcategory: "Gloss", img: SnowWhiteg },
  { id: 32, name: "21581 Royal White", category: "Shaker", subcategory: "Gloss", img: RoyalWhiteg },
  { id: 34, name: "21941 Candy White", category: "Shaker", subcategory: "Gloss", img: CandyWhiteg },
  { id: 36, name: "21081 White Lily", category: "Shaker", subcategory: "Gloss", img: WhiteLilyg },
  { id: 38, name: "21099 Royal Grey", category: "Shaker", subcategory: "Gloss", img: RoyalGreyg },
  { id: 40, name: "21089 Ash Grey", category: "Shaker", subcategory: "Gloss", img: AshGreyg },
  { id: 42, name: "21009 Grey Stone", category: "Shaker", subcategory: "Gloss", img: GreyStoneg },
  { id: 44, name: "21321 Pumic Grey", category: "Shaker", subcategory: "Gloss", img: PumicGreyg },
  { id: 46, name: "22079 Dove Grey", category: "Shaker", subcategory: "Gloss", img: DoveGreyg },
  { id: 48, name: "22059 Gothic Grey", category: "Shaker", subcategory: "Gloss", img: GothicGreyg },
  { id: 50, name: "21039 Misty Grey", category: "Shaker", subcategory: "Gloss", img: MistyGreyg },
  { id: 52, name: "22119 Autumn Leaf", category: "Shaker", subcategory: "Gloss", img: AutumnLeafg },
  { id: 54, name: "22129 Cobble Stone", category: "Shaker", subcategory: "Gloss", img: CobbleStoneg },
  { id: 56, name: "22099 Slate", category: "Shaker", subcategory: "Gloss", img: Slateg },
  { id: 58, name: "22109 Pearl Black", category: "Shaker", subcategory: "Gloss", img: PearlBlackg },
  { id: 60, name: "21066 Black", category: "Shaker", subcategory: "Gloss", img: Blackg },
  { id: 62, name: "21087 Almond", category: "Shaker", subcategory: "Gloss", img: Almondg },
  { id: 64, name: "21387 Corn", category: "Shaker", subcategory: "Gloss", img: Corng },
  { id: 66, name: "21017 Magnolia", category: "Shaker", subcategory: "Gloss", img: Magnoliag },
  { id: 68, name: "22107 British Buff", category: "Shaker", subcategory: "Gloss", img: BritishBuffg },
  { id: 70, name: "21054 Light Beige", category: "Shaker", subcategory: "Gloss", img: LightBeigeg },
  { id: 72, name: "21061 Peanut", category: "Shaker", subcategory: "Gloss", img: Peanutg },
  { id: 74, name: "21051 Barley", category: "Shaker", subcategory: "Gloss", img: Barleyg },
  { id: 76, name: "21007 Oyster", category: "Shaker", subcategory: "Gloss", img: Oysterg },
  { id: 78, name: "21027 Irish Cream", category: "Shaker", subcategory: "Gloss", img: IrishCreamg },
  { id: 80, name: "21037 Beige", category: "Shaker", subcategory: "Gloss", img: Beigeg },
  { id: 82, name: "21077 Sandal", category: "Shaker", subcategory: "Gloss", img: Sandalg },
  { id: 84, name: "21097 Khaki", category: "Shaker", subcategory: "Gloss", img: Khakig },
  { id: 86, name: "22137 Cappuccion", category: "Shaker", subcategory: "Gloss", img: Cappucciong },
  { id: 88, name: "21127 Tan", category: "Shaker", subcategory: "Gloss", img: Tang },
  { id: 90, name: "22197 Lark", category: "Shaker", subcategory: "Gloss", img: Larkg },
  { id: 92, name: "22127 Brown", category: "Shaker", subcategory: "Gloss", img: Browng },
  { id: 94, name: "21038 Mocha", category: "Shaker", subcategory: "Gloss", img: Mochag },
  { id: 96, name: "21028 Chocolate", category: "Shaker", subcategory: "Gloss", img: Chocolateg },

  { id: 97, name: "Ornamatte 1", category: "Ornamatte", subcategory: null, img: OrnaMatte },
  { id: 98, name: "Ornamatte 2", category: "Ornamatte", subcategory: null, img: OrnaMatte2 },
  { id: 99, name: "Ornamatte 3", category: "Ornamatte", subcategory: null, img: OrnaMatte3 },
  { id: 100, name: "Ornamatte 4", category: "Ornamatte", subcategory: null, img: OrnaMatte4 },
];

export default function EcommerceFilter() {
  const [search, setSearch] = useState("");
  const [fullscreenProduct, setFullscreenProduct] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const categories = useMemo(() => [...new Set(products.map((p) => p.category))], []);

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      // If clicking the same category, clear everything
      setSelectedCategory(null);
      setSelectedSubcategory(null);
      setOpenDropdown(null);
    } else {
      // Select new category
      setSelectedCategory(category);
      setSelectedSubcategory(null);
      // Only open dropdown for Shaker category
      setOpenDropdown(category === "Shaker" ? category : null);
    }
    setSidebarOpen(false);
  };

  const handleSubcategoryClick = (subcategory) => {
    setSelectedSubcategory(subcategory);
    setOpenDropdown(null);
  };

  const clearFilters = () => {
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setOpenDropdown(null);
    setSearch("");
  };

  const filteredProducts = products.filter((p) => {
    const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    
    // If no category is selected, show all products
    if (!selectedCategory) {
      return matchesSearch;
    }
    
    // If a specific category is selected (including Shaker)
    // Only show products that match exactly that category
    if (selectedCategory !== "Shaker") {
      return matchesSearch && p.category === selectedCategory;
    }
    
    // For Shaker category
    if (selectedCategory === "Shaker") {
      // If subcategory is selected, only show Shaker products with that subcategory
      if (selectedSubcategory) {
        return matchesSearch && p.category === "Shaker" && p.subcategory === selectedSubcategory;
      }
      // If no subcategory selected, show all Shaker products (both Matte and Gloss)
      return matchesSearch && p.category === "Shaker";
    }
    
    return matchesSearch;
  });

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      {/* Mobile Menu Button */}
      <button
        className="md:hidden p-4 text-white fixed top-20 left-4 z-40 rounded-lg shadow-lg"
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
      >
        ☰
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-[75px] left-0 h-full w-64 text-white p-6 shadow-lg transform transition-transform duration-300 z-40 overflow-y-auto
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
        style={{
          backgroundColor: "var(--color-primary-500)",
        }}
      >
        <button
          className="absolute top-4 right-4 text-2xl font-bold md:hidden"
          onClick={() => setSidebarOpen(false)}
          style={{ color: "var(--color-white)" }}
          aria-label="Close menu"
        >
          ✕
        </button>

        <h2 className="text-4xl font-extrabold mb-6 text-center md:text-left tracking-wide bell-mt-primary" style={{ color: "var(--color-white)" }}>
          Styles
        </h2>

        <input
          type="text"
          placeholder="🔍 Search product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border text-black p-2 rounded-lg mb-6 focus:outline-none focus:ring-2 inter-secondary"
          style={{
            borderColor: "var(--border-light)",
          }}
        />

        <div className="space-y-3">
          {categories.map((category) => (
            <div key={category} className="relative">
              <span
                onClick={() => handleCategoryClick(category)}
                className={`block cursor-pointer font-medium text-base sm:text-sm md:text-sm lg:text-lg truncate px-1 transition inter-secondary ${
                  selectedCategory === category ? "font-bold underline" : ""
                }`}
                style={{
                  color: selectedCategory === category ? "var(--color-accent-500)" : "var(--color-white)",
                }}
              >
                {category}
              </span>
              
              {/* Dropdown for Shaker category */}
              {openDropdown === category && category === "Shaker" && (
                <div className="mt-2 ml-4 space-y-2 border-l-2 pl-3 border-white/30">
                  <span
                    onClick={() => handleSubcategoryClick("Matte")}
                    className={`block cursor-pointer text-sm transition inter-secondary ${
                      selectedSubcategory === "Matte" ? "font-bold underline" : ""
                    }`}
                    style={{
                      color: selectedSubcategory === "Matte" ? "var(--color-accent-500)" : "var(--color-white)",
                    }}
                  >
                    Matte
                  </span>
                  <span
                    onClick={() => handleSubcategoryClick("Gloss")}
                    className={`block cursor-pointer text-sm transition inter-secondary ${
                      selectedSubcategory === "Gloss" ? "font-bold underline" : ""
                    }`}
                    style={{
                      color: selectedSubcategory === "Gloss" ? "var(--color-accent-500)" : "var(--color-white)",
                    }}
                  >
                    Gloss
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Products Grid */}
      <div className="flex-1 md:ml-64 p-8 overflow-y-auto" style={{ backgroundColor: "var(--color-gray-50)" }}>
        <h1 className="text-5xl md:text-7xl font-semibold text-center mb-6 p-5 tracking-wide bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
          Our Brochure
        </h1>

        {/* Active Filter Display */}
        {(selectedCategory || selectedSubcategory || search) && (
          <div className="flex justify-center gap-3 mb-6 flex-wrap">
            {selectedCategory && (
              <div 
                className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
                style={{
                  backgroundColor: "var(--color-primary-100)",
                  color: "var(--color-primary-700)",
                }}
              >
                <span className="font-bold">
                  {selectedCategory}
                  {selectedSubcategory && ` - ${selectedSubcategory}`}
                </span>
                <button
                  onClick={clearFilters}
                  className="text-lg font-bold transition hover:opacity-70"
                  style={{ color: "var(--color-primary-700)" }}
                  aria-label="Clear filter"
                >
                  ✕
                </button>
              </div>
            )}
            {search && (
              <div 
                className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
                style={{
                  backgroundColor: "var(--color-primary-100)",
                  color: "var(--color-primary-700)",
                }}
              >
                <span className="font-bold">Search: {search}</span>
                <button
                  onClick={() => setSearch("")}
                  className="text-lg font-bold transition hover:opacity-70"
                  style={{ color: "var(--color-primary-700)" }}
                  aria-label="Clear search"
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        )}

        {/* Products List */}
        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
            {filteredProducts.map((p) => (
              <div
                key={p.id}
                className="w-full md:w-[75%] cursor-pointer flex flex-col items-center bg-white rounded-xl shadow-lg transition transform hover:-translate-y-1 overflow-hidden mx-auto hover:shadow-2xl"
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: p.category === "Ornamatte" 
                    ? "0 0 0 4px var(--color-primary-500), 0 20px 25px -5px rgba(0,0,0,0.1)" 
                    : "var(--shadow-medium)",
                }}
                onClick={() => setFullscreenProduct(p)}
              >
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-auto max-h-[75vh] object-contain rounded-md"
                />
                <p
                  className="text-xl font-bold py-4 text-center bell-mt-primary"
                  style={{
                    color: p.category === "Ornamatte" ? "var(--color-primary-600)" : "var(--color-gray-900)",
                  }}
                >
                  {p.name} {p.subcategory && `(${p.subcategory})`}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg text-center pt-20 inter-secondary" style={{ color: "var(--color-gray-600)" }}>
            No products found
          </p>
        )}
      </div>

      {/* Fullscreen Modal - Centered Image Without Name */}
      {fullscreenProduct && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
          onClick={() => setFullscreenProduct(null)}
        >
          <button
            className="absolute top-6 right-6 text-4xl font-bold transition hover:opacity-70 z-50"
            style={{ color: "var(--color-white)" }}
            onClick={(e) => {
              e.stopPropagation();
              setFullscreenProduct(null);
            }}
            aria-label="Close fullscreen view"
          >
            ✕
          </button>
          <div 
            onClick={(e) => e.stopPropagation()}
            className="flex items-center justify-center w-full h-full"
          >
            <img
              src={fullscreenProduct.img}
              alt={fullscreenProduct.name}
              loading="lazy"
              className="max-h-[90%] max-w-[90%] object-contain rounded-xl shadow-xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}